import React, { useMemo } from "react";

const CustomHeader = ({
                        displayName,
                        column,
                        api,
                        selectedColumns,
                        setSelectedColumns,
                      }) => {
  const colId = column?.colId;
  const checked = useMemo(() => {
    if (!colId) return false;
    return (selectedColumns || []).includes(colId);
  }, [selectedColumns, colId]);

  const onCheckboxChange = () => {
    if (!api || !colId) return;

    setSelectedColumns((prev) => {
      const current = prev || [];
      if (current.includes(colId)) {
        return current.filter((id) => id !== colId);
      }
      return [...current, colId];
    });
  };

  return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
            type="checkbox"
            checked={checked}
            onChange={onCheckboxChange}
            style={{ marginRight: "5px" }}
        />
        <span>{displayName}</span>
      </div>
  );
};

export default CustomHeader;
